import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { orgapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});

export const fetchPieChartDataSuccess = (pieChartData: any, piechartOptions: any) => ({
    type: 'FETCH_PIE_CHART_DATA_SUCCESS',
    payload: { pieChartData, piechartOptions }
});

export const fetchOrgChartDataSuccess = (orgChartData: any, orgchartOptions: any) => ({
    type: 'FETCH_ORGANISATION_CHART_DATA_SUCCESS',
    payload: { orgChartData, orgchartOptions }
});
export const fetchTableDataSuccess = (orgTableData: any) => ({
    type: 'FETCH_Org_Table_CHART_DATA_SUCCESS',
    payload: { orgTableData }
});
//To get list of officers data
export const fetchData = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid };
            const apiname = orgapi.orgdashboard;
            const response = await LoginService.getData(apiname, payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
// //To get pie chart data
// export const fetchPieChartData = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//             try {
//                 const payload = { q: 3,userid:uid };
//                 const apiname = orgapi.orgdashcharts;
//                 const response = await LoginService.getData(apiname,payload)
//                 if (Array.isArray(response) && response.length > 0) {
//                     const documentStyle = getComputedStyle(document.documentElement);
//                     const labels = response.map(item => item.label); 
//                     const values = response.map(item => item.value);
//                     const data = {
//                         // labels: ['A', 'B', 'C'],
//                         labels: labels,
//                         datasets: [
//                             {
//                                // data: response
//                                data: values
//                             }
//                         ]
//                     }
//                     const options = {
//                         plugins: {
//                             legend: {
//                                 labels: {
//                                     usePointStyle: true
//                                 }
//                             }
//                         }
//                     };
//                     dispatch(fetchPieChartDataSuccess(data, options));
//                 }
//             } catch (error) {
//                 console.error('Error fetching chart data:', error);
//             }
//     };
// };
// //To get bar chart data
// export const fetchOrgChartData = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = { q: 4 ,userid:uid};
//             const apiname = orgapi.orgdashcharts;
//             const response = await LoginService.getData(apiname,payload)
//             if (Array.isArray(response) && response.length > 0) {
//               const labels = response.map(item => item.label); 
//               const values = response.map(item => item.value);
//               console.log("values",values)
//               const data = {
//                 labels: labels,
//                 datasets: [
//                   {
//                     label:'Members',
//                     data: 
//                       values
//                     ,
//                     backgroundColor: [
//                       'rgba(255, 159, 64, 0.2)',
//                       'rgba(75, 192, 192, 0.2)',
//                       'rgba(54, 162, 235, 0.2)',
//                       'rgba(153, 102, 255, 0.2)',
//                     ],
//                     borderColor: [
//                       'rgb(255, 159, 64)',
//                       'rgb(75, 192, 192)',
//                       'rgb(54, 162, 235)',
//                       'rgb(153, 102, 255)',
//                     ],
//                     borderWidth: 1,
//                   },
//                 ],
//               };
//               const options = {
//                 scales: {
//                   y: {
//                     beginAtZero: true,
//                   },
//                 },
//               };
//               dispatch(fetchOrgChartDataSuccess(data, options));
//             }
//           } catch (error) {
//             console.error('Error fetching chart data:', error);
//           }

//     };
// };

// DONATIONS PIE / DOUGHNUT CHART
export const fetchPieChartData = (uid: any) => {

    return async (dispatch: Dispatch) => {

        try {

            const payload = {
                q: 3,
                userid: uid
            };

            const apiname = orgapi.orgdashcharts;

            const response = await LoginService.getData(
                apiname,
                payload
            );

            if (
                Array.isArray(response) &&
                response.length > 0
            ) {

                const documentStyle =
                    getComputedStyle(document.documentElement);

                const labels = response.map(
                    (item) => item.label
                );

                const values = response.map(
                    (item) => item.value
                );

                const data = {

                    labels,

                    datasets: [
                        {
                            label: 'Donations',

                            data: values,

                            backgroundColor: [
                                '#3B82F6',
                                '#10B981',
                                '#F59E0B',
                                '#EF4444',
                                '#8B5CF6',
                                '#06B6D4'
                            ],

                            hoverBackgroundColor: [
                                '#2563EB',
                                '#059669',
                                '#D97706',
                                '#DC2626',
                                '#7C3AED',
                                '#0891B2'
                            ],

                            borderColor: '#ffffff',

                            borderWidth: 3,

                            hoverOffset: 15
                        }
                    ]
                };

                const options = {

                    maintainAspectRatio: false,

                    responsive: true,

                    cutout: '60%',

                    plugins: {

                        legend: {

                            position: 'bottom',

                            labels: {

                                usePointStyle: true,

                                padding: 20,

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color'
                                    ),

                                font: {
                                    size: 13,
                                    weight: '600'
                                }
                            }
                        },

                        tooltip: {

                            backgroundColor: '#111827',

                            titleColor: '#ffffff',

                            bodyColor: '#ffffff',

                            padding: 12,

                            cornerRadius: 10
                        }
                    },

                    animation: {

                        animateRotate: true,

                        animateScale: true
                    }
                };

                dispatch(
                    fetchPieChartDataSuccess(
                        data,
                        options
                    )
                );
            }

        } catch (error) {

            console.error(
                'Error fetching chart data:',
                error
            );
        }
    };
};
// FUND MANAGER BAR CHART
export const fetchOrgChartData = (uid: any) => {

    return async (dispatch: Dispatch) => {

        try {

            const payload = {
                q: 4,
                userid: uid
            };

            const apiname = orgapi.orgdashcharts;

            const response = await LoginService.getData(
                apiname,
                payload
            );

            if (
                Array.isArray(response) &&
                response.length > 0
            ) {

                const documentStyle =
                    getComputedStyle(document.documentElement);

                const labels = response.map(
                    (item) => item.label
                );

                const values = response.map(
                    (item) => item.value
                );

                const data = {

                    labels,

                    datasets: [
                        {
                            label: 'Fund Managers',

                            data: values,

                            borderRadius: 14,

                            borderSkipped: false,

                            maxBarThickness: 55,

                            backgroundColor: [
                                '#3B82F6',
                                '#10B981',
                                '#F59E0B',
                                '#8B5CF6',
                                '#EF4444',
                                '#06B6D4'
                            ],

                            hoverBackgroundColor: [
                                '#2563EB',
                                '#059669',
                                '#D97706',
                                '#7C3AED',
                                '#DC2626',
                                '#0891B2'
                            ]
                        }
                    ]
                };

                const options = {

                    maintainAspectRatio: false,

                    responsive: true,

                    plugins: {

                        legend: {

                            position: 'top',

                            labels: {

                                usePointStyle: true,

                                padding: 20,

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color'
                                    ),

                                font: {
                                    size: 13,
                                    weight: '600'
                                }
                            }
                        },

                        tooltip: {

                            backgroundColor: '#111827',

                            titleColor: '#ffffff',

                            bodyColor: '#ffffff',

                            padding: 12,

                            cornerRadius: 10
                        }
                    },

                    scales: {

                        x: {

                            grid: {
                                display: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 12,
                                    weight: '500'
                                }
                            }
                        },

                        y: {

                            beginAtZero: true,

                            grid: {

                                color: '#e5e7eb',

                                drawBorder: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 12
                                }
                            }
                        }
                    },

                    animation: {

                        duration: 1800,

                        easing: 'easeOutQuart'
                    }
                };

                dispatch(
                    fetchOrgChartDataSuccess(
                        data,
                        options
                    )
                );
            }

        } catch (error) {

            console.error(
                'Error fetching chart data:',
                error
            );
        }
    };
};

export const fetchTableData = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { uid: uid, q: 2 };
            const apiname = orgapi.orgdashlist;
            const response = await LoginService.getData(apiname, payload)
            dispatch(fetchTableDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};